import { tap } from 'rxjs/operators';
import { DataService, HttpMethod } from './data.service';
import { UserType } from 'src/app/interfaces/user';
import { User } from './../interfaces/user';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  public uid: string;
  private user: User;

  private isLoginSubject = new BehaviorSubject<boolean>(false);
  private isStudentSubject = new BehaviorSubject<boolean>(false);
  private isAdminSubject = new BehaviorSubject<boolean>(false);
  private isSuperAdminSubject = new BehaviorSubject<boolean>(false);

  constructor(
    private data: DataService
    ) {
      this.getUser().then((user) => this.isLoginSubject.next(!!user));

    this.isLoginSubject.asObservable().subscribe(async () => {
      const user = await this.getUser();

      this.isAdminSubject.next(user && (user.type === UserType.SchoolAdmin || user.type === UserType.SuperAdmin));
      this.isSuperAdminSubject.next(user && user.type === UserType.SuperAdmin);
      this.isStudentSubject.next(user && user.type === UserType.Student);
    })
  }

  async getUser(force = false){
    const token = localStorage.getItem('token');

    if(!this.user || force){
      if(token){
        const res = await this.data.getProfile().toPromise();

        if(res && res.data){
          this.user = res.data;
        }else{
          localStorage.removeItem('token');
          this.user = undefined;
        }
      }
    }

    return this.user;
  }

  isStudent = () => this.isStudentSubject.asObservable();

  isSuperAdmin = () => this.isSuperAdminSubject.asObservable();

  isSchoolAdmin = () => this.isAdminSubject.asObservable();

  isAuthenticated = () => this.isLoginSubject.asObservable();

  signup(user){
    return this.data.request(HttpMethod.POST, `/auth/register`, user).pipe(
      tap((v) => {
        if(v.token){
          this.data.setToken(v.token);
        }
      })
    )
  }

  login(user): Observable<any>{
    console.log(user);

    return this.data.request(HttpMethod.POST, '/auth/login', user).pipe(
      tap(res => {
        if(res && res.data){
          const userInfo = res.data;

          console.log(userInfo, UserType.Teacher);

          switch(userInfo.type){
            case UserType.Teacher: {
              if(userInfo.profile_picture && userInfo.introduction){
                this.user = userInfo;
                this.isLoginSubject.next(true);
                this.data.setToken(res.token);
              }else{
                this.data.setToken(res.token, true);
              }
              break;
            }
            case UserType.Student: {
              if(userInfo.children && userInfo.children.length){

                console.log(userInfo.children.length);

                this.user = userInfo;
                this.isLoginSubject.next(true);
                this.data.setToken(res.token);
              }else{
                this.data.setToken(res.token, true);
              }
              break;
            }
            case UserType.SchoolAdmin: {
              this.user = userInfo;
              this.isLoginSubject.next(true);
              this.data.setToken(res.token);
              break;
            }
            case UserType.SuperAdmin: {
              this.user = userInfo;
              this.isLoginSubject.next(true);
              this.data.setToken(res.token);
              break;
            }
            case UserType.UnApprovedTeacher: {
              if(userInfo.profile_picture && userInfo.introduction){
                this.user = userInfo;
                this.isLoginSubject.next(true);
                this.data.setToken(res.token);
              }else{
                this.data.setToken(res.token, true);
              }
              break;
            }
          }
        }
      })
    )
  }

  async logout() {
    localStorage.removeItem('token');
    this.user = undefined;
    this.isLoginSubject.next(false);
  }
}
